module.exports = __webpack_public_path__ + "images/emoji/u55b6.0b52b30918ee5dafd3b2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u55b6.png
// module id = RlJg
// module chunks = 2